export default __webpack_public_path__ + "static/media/calendar_meeting_detail.60560fc3.svg";